export default {
  'zh-CN': [{
    'no': 'A',
    'name': '马克思主义、列宁主义、毛泽东思想、邓小平理论',
    'path': ';A:马克思主义、列宁主义、毛泽东思想、邓小平理论;'
  },
  {
    'no': 'B',
    'name': '哲学、宗教',
    'path': ';B:哲学、宗教;'
  },
  {
    'no': 'C',
    'name': '社会科学总论',
    'path': ';C:社会科学总论;'
  },
  {
    'no': 'D',
    'name': '政治、法律',
    'path': ';D:政治、法律;'
  },
  {
    'no': 'E',
    'name': '军事',
    'path': ';E:军事;'
  },
  {
    'no': 'F',
    'name': '经济',
    'path': ';F:经济;'
  },
  {
    'no': 'G',
    'name': '文化、科学、教育、体育',
    'path': ';G:文化、科学、教育、体育;'
  },
  {
    'no': 'H',
    'name': '语言、文字',
    'path': ';H:语言、文字;'
  },
  {
    'no': 'I',
    'name': '文学',
    'path': ';I:文学;'
  },
  {
    'no': 'J',
    'name': '艺术',
    'path': ';J:艺术;'
  },
  {
    'no': 'K',
    'name': '历史、地理',
    'path': ';K:历史、地理;'
  },
  {
    'no': 'N',
    'name': '自然科学总论',
    'path': ';N:自然科学总论;'
  },
  {
    'no': 'O',
    'name': '数理科学和化学',
    'path': ';O:数理科学和化学;'
  },
  {
    'no': 'P',
    'name': '天文学、地球科学',
    'path': ';P:天文学、地球科学;'
  },
  {
    'no': 'Q',
    'name': '生物科学',
    'path': ';Q:生物科学;'
  },
  {
    'no': 'R',
    'name': '医药、卫生',
    'path': ';R:医药、卫生;'
  },
  {
    'no': 'S',
    'name': '农业科学',
    'path': ';S:农业科学;'
  },
  {
    'no': 'T',
    'name': '工业技术',
    'path': ';T:工业技术;'
  },
  {
    'no': 'U',
    'name': '交通运输',
    'path': ';U:交通运输;'
  },
  {
    'no': 'V',
    'name': '航空、航天',
    'path': ';V:航空、航天;'
  },
  {
    'no': 'X',
    'name': '环境科学、安全科学',
    'path': ';X:环境科学、安全科学;'
  },
  {
    'no': 'Z',
    'name': '综合性图书',
    'path': ';Z:综合性图书;'
  }],
  'en-US': []
}



// WEBPACK FOOTER //
// ./src/table-data.js